window.addEventListener("load", () => {
  if ($("#systems-with-missing-info").length > 0) {
    $.getScript("/missing_info_systems")
  }

  $("div.city-state-zip select[id$=_state_id]").each(function () {
    var stateInput = $(this)
    var countyInput = stateInput.parents(".city-state-zip").find(".select[id$=_county_id]:first")

    if (countyInput.length > 0) {
      return stateInput.hasDependentSelect(countyInput, {
        targetUrl: "/counties",
        requestParamsGenerator: function() {
          return {
            state_id: stateInput.val()
          }
        }
      }).change()
    }
  })

  return $("body").on("click", ".accordion-expand-collapse a", function() {
    $("#system_accordion .ui-accordion-header:not(.ui-state-active)").next().slideToggle()
    $(this).html($(this).text() === " Expand all" ? "<i class='glyphicon glyphicon-resize-small'></i> Collapse all" : "<i class=\"glyphicon glyphicon-resize-full\"></i> Expand all")
  })
})
